import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let DatavPage = class DatavPage extends Vue {
  get extraStyles() {
    let styles = {};
    styles.width = this.size ? this.size[0] + 'px' : '1920px';
    styles.height = this.size ? this.size[1] + 'px' : '1080px';
    if (this.background) {
      styles.background = this.background;
    }
    if (this.url) {
      styles.background = `url(${this.url})`;
    }
    return styles;
  }
};
DatavPage.componentName = 'DatavPage';
__decorate([Prop(String)], DatavPage.prototype, "size", void 0);
__decorate([Prop({
  default: '#fff'
})], DatavPage.prototype, "background", void 0);
__decorate([Prop(String)], DatavPage.prototype, "url", void 0);
DatavPage = __decorate([Component({
  name: 'DatavPage'
})], DatavPage);
export default DatavPage;